import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPartner = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M20.7997 0C18.7379 0 17.0664 1.67147 17.0664 3.73333C17.0687 5.7942 18.7389 7.46433 20.7997 7.46667C22.8616 7.46667 24.5331 5.7952 24.5331 3.73333C24.5331 1.67147 22.8616 0 20.7997 0ZM20.7997 6.4C19.327 6.4 18.1331 5.20607 18.1331 3.73333C18.1348 2.26133 19.3277 1.0684 20.7997 1.06667C22.2725 1.06667 23.4664 2.2606 23.4664 3.73333C23.4664 5.20607 22.2725 6.4 20.7997 6.4Z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.3994 8H19.1994C16.5497 8.00293 14.4023 10.1503 14.3994 12.8V21.8667H16.5327V32H17.5994V19.7333H16.5327V20.8H15.4661V12.8C15.4684 10.7391 17.1385 9.069 19.1994 9.06667H22.3994C24.4603 9.069 26.1304 10.7391 26.1327 12.8V20.8H25.0661V19.7333H23.9994V32H25.0661V21.8667H27.1994V12.8C27.1965 10.1503 25.0491 8.00293 22.3994 8Z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.3333 21.8667H20.2666V32H21.3333V21.8667Z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1336 5.3335C8.36626 5.3335 6.93359 6.76616 6.93359 8.5335C6.93533 10.3001 8.36699 11.7318 10.1336 11.7335C11.9009 11.7335 13.3336 10.3008 13.3336 8.5335C13.3336 6.76616 11.9009 5.3335 10.1336 5.3335ZM10.1336 10.6668C8.95539 10.6668 8.00026 9.7117 8.00026 8.5335C8.00026 7.3553 8.95539 6.40016 10.1336 6.40016C11.3118 6.40016 12.2669 7.3553 12.2669 8.5335C12.2669 9.7117 11.3118 10.6668 10.1336 10.6668Z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.53314 12.2666C6.47227 12.2689 4.80214 13.9391 4.7998 15.9999V23.9999H6.93314V31.9999H7.9998V21.8666H6.93314V22.9333H5.86647V15.9999C5.8682 14.5279 7.06114 13.335 8.53314 13.3333H13.3331V12.2666H8.53314Z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.3333 22.9334V21.8667H12.2666V32H13.3333V24H15.4666V22.9334H13.3333Z",
					fill: "#808080"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.6663 24H9.59961V32H10.6663V24Z",
					fill: "#808080"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPartner);
export default ForwardRef;
